module.exports = __webpack_public_path__ + "static/media/LockerEnviroDesigner.48f8bbfe.jpg";